export const SET_TOKEN = 'SET_TOKEN'
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR'
export const IS_USER_AUTHENTICATED = 'IS_USER_AUTHENTICATED'
export const SET_ISAUTH_LOADING = 'SET_ISAUTH_LOADING'
export const SET_MFA_SESSION = 'SET_MFA_SESSION'
export const LIST_PORTAL_SAME_USER = 'LIST_PORTAL_SAME_USER'

export const REGIONS_DETAIL_SUCCESS = 'REGIONS_DETAIL_SUCCESS'
export const GET_REGION_LIST = 'GET_REGION_LIST'
export const REGION_LIST_ERROR = 'GET_REGION_LIST_ERROR'

// Create New Request Const
export const REQUEST_STAGE = 'REQUEST_STAGE'

export const REQUEST_TYPE = 'REQUEST_TYPE'
export const REQUEST_TYPE_SUCCESS = "REQUEST_TYPE_SUCCESS"
export const REQUEST_TYPE_ERROR = "REQUEST_TYPE_ERROR"

export const SET_ADDRESS_COLLECTIONS = "GET_ADDRESS_COLLECTIONS"
export const DELETE_ADDRESS_COLLECTION_SUCCESS = "DELETE_ADDRESS_COLLECTION_SUCCESS"
export const ADD_ADDRESS_COLLECTION_DETAILS_SUCCESS = "ADD_ADDRESS_COLLECTION_DETAILS_SUCCESS"
export const ADDRESS_COLLECTION_BY_SITE_ID_SUCCESS = "ADDRESS_COLLECTION_BY_SITE_ID_SUCCESS"
export const UPDATED_COLLECTION_ADDRESS = "UPDATED_COLLECTION_ADDRESS"
export const PORTAL_COLLECTION_ADDRESS_ERROR = "PORTAL_COLLECTION_ADDRESS_ERROR"
export const DESTINATION_ADDRESS_SUCCESS = "DESTINATION_ADDRESS_SUCCESS"
export const ADD_ADDRESS_COLLECTION_ERROR = "ADD_ADDRESS_COLLECTION_ERROR"
export const ADDRESS_COLLECTION_BY_SITE_ID_ERROR = "ADDRESS_COLLECTION_BY_SITE_ID_ERROR"
export const ADD_ADDRESS_COLLECTION_SUCCESS = "ADD_ADDRESS_COLLECTION_SUCCESS"
export const GET_ADDRESS_LIST = "GET_ADDRESS_LIST"
export const NEW_ADDRESS_ADDED = "NEW_ADDRESS_ADDED"
export const COUNTRIES_DETAIL_SUCCESS = "COUNTRIES_DETAIL_SUCCESS"
export const TRUCK_DETAIL_SUCCESS = "TRUCK_DETAIL_SUCCESS"
export const REQUEST_ERROR = "REQUEST_ERROR"
export const TRUCK_ERROR = "TRUCK_ERROR"
export const TRUCKS_ADDED_SUCCESS = "TRUCKS_ADDED_SUCCESS"
export const SET_ADD_NEW_TRUCK_SIZE_RESPONSE = "SET_ADD_NEW_TRUCK_SIZE_RESPONSE"
export const GET_REQUEST = "GET_REQUEST"
export const GET_REQUEST_ID = "GET_REQUEST_ID"
export const GET_REQUEST_ID_ERROR = "GET_REQUEST_ID_ERROR"
export const IMPORT_EOS_REQUEST = "IMPORT_EOS_REQUEST"

export const GET_ASSETS = "GET_ASSETS_TYPE"
export const GET_ASSETS_TYPE_SUCCESS = "GET_ASSETS_TYPE_SUCCESS"
export const GET_PROGRAM_ASSETS_TYPE_SUCCESS = "GET_PROGRAM_ASSETS_TYPE_SUCCESS"
export const GET_ASSETS_TYPE_ERROR = "GET_ASSETS_TYPE_ERROR"

export const GET_SERVICE_GROUPS_SUCCESS = "GET_SERVICE_GROUPS_SUCCESS"
export const GET_SERVICE_GROUPS_ERROR = "GET_SERVICE_GROUPS_ERROR"

//GET : Asset list saved under request Id
export const GET_ASSETS_UNDER_REQUEST = "GET_ASSETS_UNDER_REQUES_TYPE"
export const GET_ASSETS_UNDER_REQUEST_TYPE_SUCCESS = "GET_ASSETS_UNDER_REQUEST_TYPE_SUCCESS"
export const GET_ASSETS_UNDER_REQUEST_TYPE_ERROR = "GET_ASSETS_UNDER_REQUEST_TYPE_ERROR"

export const GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS = "GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS"
export const GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS_ON_DIALOG = "GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS_ON_DIALOG"
export const GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_ERROR = "GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_ERROR"


//For GET: Recycling Partner
export const GET_RECYLCLEPARTNER_LIST = "GET_RECYLCLEPARTNER_LIST_TYPE"
export const GET_RECYLCLEPARTNER_LIST_TYPE_SUCCESS = "GET_RECYLCLEPARTNER_LIST_TYPE_SUCCESS"
export const GET_RECYLCLEPARTNER_LIST_TYPE_ERROR = "GET_RECYLCLEPARTNER_LIST_TYPR_ERROR"

//

export const UPDATED_REQUEST = "UPDATED_REQUEST"
export const UPDATED_REQUEST_SUCCESS = "UPDATED_REQUEST_SUCCESS"
export const UPDATED_REQUEST_ERROR = "UPDATED_REQUEST_ERROR"

export const ABIS_DATA = "ABIS_DATA"

export const ASSETS_DETAIL_SAVE = "ASSETS_DETAIL_SAVE"
export const ASSETS_DETAIL_SAVE_SUCCESS = "ASSETS_DETAIL_SAVE_SUCCESS"
export const ASSETS_DETAIL_SAVE_ERROR = "ASSETS_DETAIL_SAVE_ERROR"


export const REQUEST_STAGE_INPUT = "REQUEST_STAGE_INPUT"
export const REQUEST_STAGE_INPUT_SUCCESS = "REQUEST_STAGE_INPUT_SUCCESS"
export const REQUEST_STAGE_INPUT_ERROR = "REQUEST_STAGE_INPUT_ERROR"

export const CONTACT_STAGE_SUBMIT = "CONTACT_STAGE_SUBMIT"
export const CONTACT_STAGE_SUBMIT_SUCCESS = "CONTACT_STAGE_SUBMIT_SUCCESS"
export const CONTACT_STAGE_SUBMIT_ERROR = "CONTACT_STAGE_SUBMIT_ERROR"


export const LOCATION_STAGE_SUBMIT = "LOCATION_STAGE_SUBMIT"
export const LOCATION_STAGE_SUBMIT_SUCCESS = "LOCATION_STAGE_SUBMIT_SUCCESS"
export const LOCATION_STAGE_SUBMIT_ERROR = "LOCATION_STAGE_SUBMIT_ERROR"

export const DEVICE_STAGE_SUBMIT = "DEVICE_STAGE_SUBMIT"
export const DEVICE_STAGE_SUBMIT_SUCCESS = "DEVICE_STAGE_SUBMIT_SUCCESS"
export const DEVICE_STAGE_SUBMIT_ERROR = "DEVICE_STAGE_SUBMIT_ERROR"

export const PACKING_DETAIL_SUBMIT = "PACKING_DETAIL_SUBMIT"
export const PACKING_DETAIL_SUBMIT_SUCCESS = "PACKING_DETAIL_SUBMIT_SUCCESS"
export const PACKING_DETAIL_SUBMIT_ERROR = "PACKING_DETAIL_SUBMIT_ERROR"

export const GET_SERVICES = "GET_SERVICES"
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS"
export const GET_SERVICES_ERROR = "GET_SERVICES_ERROR"

export const GET_CLIENT_SERVICE_TYPE = "GET_CLIENT_SERVICE_TYPE"

export const SELECTED_SERVICES_SUCCESS = "SELECTED_SERVICES_SUCCESS"
// export const GET_LOGISTICS_OPTION = "GET_LOGISTICS_OPTION"
export const ASSETS_DETAIL_SAVE_LIST = "ASSETS_DETAIL_SAVE_LIST"
export const REQUEST_QUOTE_INFO = "REQUEST_QUOTE_INFO"

export const CLIENT_SERVICES_SUCCESS = "CLIENT_SERVICES_SUCCESS"
export const EXTRA_SERVICES_INFORMATION = "EXTRA_SERVICES_INFORMATION"
export const CLIENT_SERVICES_ERROR = "CLIENT_SERVICES_ERROR"
export const PACKING_SERVICES_INFORMATION = "PACKING_SERVICES_INFORMATION"
export const PORTAL_PACKING_GRADES = "PORTAL_PACKING_GRADES"
// Dashboard Const

export const REQUEST_LIST = "REQUEST_LIST"
export const REQUEST_LIST_SUCCESS = "REQUEST_LIST_SUCCESS"
export const REQUEST_LIST_ERROR = "REQUEST_LIST_ERROR"

export const REQUEST_COUNT = "REQUEST_COUNT"
export const REQUEST_COUNT_SUCCESS = "REQUEST_COUNT_SUCCESS"
export const REQUEST_COUNT_ERROR = "REQUEST_COUNT_ERROR"
export const REQUEST_IDS_SUCCESS = "REQUEST_IDS_SUCCESS"

export const REQUEST_LIST_DETAILS = "REQUEST_LIST_DETAILS"
export const REQUEST_LIST_DETAILS_SUCCESS = "REQUEST_LIST_DETAILS_SUCCESS"
export const REQUEST_LIST_DETAILS_ERROR = "REQUEST_LIST_DETAILS_ERROR"

export const SET_UNAUTHORIZED_ERROR = "SET_UNAUTHORIZED_ERROR"


//for bulk upload
export const UPLOAD_ASSET_LIST = "UPLOAD_ASSET_LIST"
export const UPLOAD_ASSET_LIST_SUCCESS = "UPLOAD_ASSET_LIST_SUCCESS"
export const BULK_ASSET_UPLOAD_SUCCESS = "BULK_ASSET_UPLOAD_SUCCESS"
export const UPLOAD_ASSET_LIST_ERROR = "UPLOAD_ASSET_LIST_ERROR"



export const ON_LOGOUT = 'ON_LOGOUT'

export const PROGRAM_DATA = 'PROGRAM_DATA'
export const PROGRAM_ERROR = 'PROGRAM_ERROR'
export const STATUSES_DATA = 'STATUSES_DATA'
export const STATUSES_LIST = 'STATUSES_LIST'
export const STATUSES_ERROR = 'STATUSES_ERROR'
export const PORTAL_ERROR = 'PORTAL_ERROR'
export const SET_PORTAL_LOGO = 'SET_PORTAL_LOGO'
export const CURRENT_PORTAL = 'CURRENT_PORTAL'
export const CURRENT_CLIENT = 'CURRENT_CLIENT'
export const REQUEST_STATUS_DATA = 'REQUEST_STATUS_DATA'
export const REQUEST_STATUS_ERROR = 'REQUEST_STATUS_ERROR'

export const REQUEST_MAIL_ERROR = "REQUEST_MAIL_ERROR"
export const MAIL_SEND_SUCCESS = "MAIL_SEND_SUCCESS"

// change password and forgot password
export const ADMIN_CHANGE_PASSWORD_ERROR = 'ADMIN_CHANGE_PASSWORD_ERROR'
export const ADMIN_FORGOT_PASSWORD_ERROR = 'ADMIN_FORGOT_PASSWORD_ERROR'
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'

export const REQUEST_DETAIL_UPDATE = 'REQUEST_DETAIL_UPDATE'
export const REQUEST_STATUSES_ERROR = 'REQUEST_STATUSES_ERROR'

export const REQUEST_CONTACT_ERROR = 'REQUEST_CONTACT_ERROR'

export const CLIENT_TERMS_SUCCESS = "CLIENT_TERMS_SUCCESS"
export const CLIENT_TERMS_ERROR = 'CLIENT_TERMS_ERROR'

//delete asset
export const DELETE_SELECTED_ASSET = "DELETE_SELECTED_ASSET"
export const DELETE_SELECTED_SUCCESS = "DELETE_SELECTED_SUCCESS"
export const DELETE_SELECTED_ERROR = "DELETE_SELECTED_ERROR"

export const UPDATE_ASSET_LIST = "UPDATE_ASSET_LIST"
export const UPDATE_ASSET_SUCCESS = "UPDATE_ASSET_SUCCESS"
export const UPDATE_ASSET_ERROR = "UPDATE_ASSET_ERROR"

// save service
export const SAVE_SERVICE_LIST = "SAVE_SERVICE_LIST"
export const SAVE_SERVICE_SUCCESS = "SAVE_SERVICE_SUCCESS"
export const SAVE_SERVICE_ERROR = "SAVE_SERVICE_ERROR"

export const SAVED_SERVICES_UNDER_ASSET = "SAVED_SERVICES_UNDER_ASSET"
export const SAVED_SERVICES_UNDER_ASSET_SUCCESS = "SAVED_SERVICES_UNDER_ASSET_SUCCESS"
export const SAVED_SERVICES_UNDER_ASSET_ERROR = "SAVED_SERVICES_UNDER_ASSET_ERROR"

export const SAVE_REQUEST_SERVICE = "SAVE_REQUEST_SERVICE"
export const SAVE_REQUEST_SERVICE_ERROR = "SAVE_REQUEST_SERVICE_ERROR"
export const GET_REQUEST_SERVICE = "GET_REQUEST_SERVICE"
export const GET_REQUEST_SERVICE_ERROR = "GET_REQUEST_SERVICE_ERROR"
//Excel Asset
export const EXCEL_ASSET_LIST = "EXCEL_ASSET_LIST"
export const EXCEL_ASSET_SUCCESS = "EXCEL_ASSET_SUCCESS"
export const EXCEL_ASSET_ERROR = "EXCEL_ASSET_ERROR"

export const EXCEL_AVAILABLE = "EXCEL_ASSET"
export const EXCEL_AVAILABLE_SUCCESS = "EXCEL_AVAILABLE_SUCCESS"
export const EXCEL_AVAILABLE_ERROR = "EXCEL_AVAILABLE_ERROR"

export const SAVED_SERVICES_UNDER_EXCEL_ASSET = "SAVED_SERVICES_UNDER_EXCEL_ASSET"
export const SAVED_SERVICES_UNDER_EXCEL_ASSET_SUCCESS = "SAVED_SERVICES_UNDER_EXCEL_ASSET_SUCCESS"
export const SAVED_SERVICES_UNDER_EXCEL_ASSET_ERROR = "SAVED_SERVICES_UNDER_EXCEL_ASSET_ERROR"


// Get Packing & Boxes
export const GET_PACKING_PORTAL_LIST = "GET_PACKING_PORTAL_LIST"
export const GET_BOXES_LIST = "GET_BOXES_LIST"
export const BOX_OR_PACK_ERROR = "BOX_OR_PACK_ERROR"
export const PACKAGING_DETAIL_SUCCESS = "PACKAGING_DETAIL_SUCCESS"
export const PACKAGING_ERROR = "PACKAGING_ERROR"
export const DIMENSIONS_LIST = "DIMENSIONS_LIST"
export const DIMENSIONS_ERROR = "DIMENSIONS_ERROR"


// Get Label List
export const LABEL_ERROR = "LABEL_ERROR"
export const GET_LABEL_LIST = "GET_LABEL_LIST"
export const ADD_REQUEST_LABEL_SUCCESS = "ADD_REQUEST_LABEL_SUCCESS"
export const GET_REQUEST_LABEL = "GET_REQUEST_LABEL"
export const DELETE_REQUEST_LABEL = "DELETE_REQUEST_LABEL"


export const ADD_REQUEST_PACKING_SUCCESS = "ADD_REQUEST_PACKING_SUCCESS"
export const ADD_REQUEST_PACKING_ERROR = "ADD_REQUEST_PACKING_ERROR"
export const GET_REQUEST_PACKING = "GET_REQUEST_PACKING"
export const GET_REQUEST_PACKING_ERROR = "GET_REQUEST_PACKING_ERROR"
export const DELETE_REQUEST_PACKING = "DELETE_REQUEST_PACKING"

// Additional Info
export const GET_ADDITIONAL_INFO_SUCCESS = "GET_ADDITIONAL_INFO_SUCCESS"
export const SAVE_ADDITIONAL_INFO_SUCCESS = "SAVE_ADDITIONAL_INFO_SUCCESS"
export const RESET_ADDITIONAL_INFO_DATA = "RESET_ADDITIONAL_INFO_DATA"

export const REQUEST_TYPE_INPUT_FIELDS = "REQUEST_TYPE_INPUT_FIELDS"

// Program Request Stages
export const PROGRAM_REQUEST_STAGES = 'PROGRAM_REQUEST_STAGES'
export const PROGRAM_STAGE_ERROR = 'PROGRAM_STAGE_ERROR'

//Service Date
export const SAVE_SERVICE_DATE = "SAVE_SERVICE_DATE"
export const SAVE_SERVICE_DATE_ERROR = "SAVE_SERVICE_DATE_ERROR"

//Reports
export const GET_RECEPTION_REPORTS_ERROR = "GET_RECEPTION_REPORTS_ERROR"
export const GET_RECEPTION_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS"
export const GET_BOOKING_REPORTS_SUCCESS = "GET_BOOKING_REPORTS_SUCCESS"
export const GET_BOOKING_REPORTS_ERROR = "GET_BOOKING_REPORTS_ERROR"
export const GET_VALUEBACK_REPORTS_SUCCESS = "GET_VALUEBACK_REPORTS_SUCCESS"
export const GET_VALUEBACK_REPORTS_ERROR = "GET_VALUEBACK_REPORTS_ERROR"
export const GET_REVENUSHARE_REPORTS_SUCCESS = "GET_REVENUSHARE_REPORTS_SUCCESS"
export const GET_REVENUSHARE_REPORTS_ERROR = "GET_REVENUSHARE_REPORTS_ERROR"
export const GET_SERVICEFEEBOOKING_REPORTS_SUCCESS = "GET_SERVICEFEEBOOKING_REPORTS_SUCCESS"
export const GET_SERVICEFEEBOOKING_REPORTS_ERROR = "GET_SERVICEFEEBOOKING_REPORTS__ERROR"





//Charts
export const CHART_REQUEST_STATUS_SUCCESS = "CHART_REQUEST_SUCCESS"
export const CHART_REQUEST_STATUS_ERROR = "CHART_REQUEST_STATUS_ERROR"
export const CHART_REQUEST_TYPE_SUCCESS = "CHART_REQUEST_TYPE_SUCCESS"
export const CHART_REQUEST_TYPE_ERROR = "CHART_REQUEST_TYPE_ERROR"

// Portal request status Information

export const PORTAL_REQUEST_STATUS_LIST = "PORTAL_REQUEST_STATUS_LIST"
export const PROGRAM_STAGE_STATUS_LIST = "PROGRAM_STAGE_STATUS_LIST"
export const REQUEST_STATUSES_PROGRESS = "REQUEST_STATUSES_PROGRESS"
export const SELECTED_REQUEST_STATUS_SEQUENCE = "SELECTED_REQUEST_STATUS_SEQUENCE"
export const SET_REQUEST_REJECTED = "SET_REQUEST_REJECTED"

/* Request Document Functionalities */
/* Program Document Types */
export const PROGRAM_DOC_TYPE_ERROR = 'PROGRAM_DOC_TYPE_ERROR'
export const PROGRAM_DOC_TYPE_LIST = 'PROGRAM_DOC_TYPE_LIST'
export const PROGRAM_DOC_ASSET_IMAGE_TYPE = 'PROGRAM_DOC_ASSET_IMAGE_TYPE'

/* Request Document types */
export const REQUEST_DOCS_LIST = 'REQUEST_DOCS_LIST'
export const REQUEST_DOCS_ERROR = 'REQUEST_DOCS_ERROR'
export const PORTAL_DOCS_LIST = 'PORTAL_DOCS_LIST'
export const PORTAL_DOCS_ERROR = 'PORTAL_DOCS_ERROR'
export const PORTAL_DOCS_COUNT = 'PORTAL_DOCS_COUNT'
export const PORTAL_ALL_REQUEST_DOCS_LIST = 'PORTAL_ALL_REQUEST_DOCS_LIST'
export const PORTAL_ALL_REQUEST_DOCS_LIST_FOR_INDIVIDUAL_REPORTS = 'PORTAL_ALL_REQUEST_DOCS_LIST_FOR_INDIVIDUAL_REPORTS'
export const GET_INDIVIDUAL_REPORTS = 'GET_INDIVIDUAL_REPORTS'
export const GET_INDIVIDUAL_REPORTS_COUNT = 'GET_INDIVIDUAL_REPORTS_COUNT'
export const PORTAL_ALL_REQUEST_DOCS_COUNT = 'PORTAL_ALL_REQUEST_DOCS_COUNT'
export const ADDED_REQUEST_DOCUMNET = 'ADDED_REQUEST_DOCUMNET'
export const REQUEST_DOCS_DOWNLOAD = 'REQUEST_DOCS_DOWNLOAD'
export const REQUEST_DOC_DELETED = 'REQUEST_DOC_DELETED'
export const REQUEST_DOC_ITEM = 'REQUEST_DOC_ITEM'
export const FETCH_ALL_REPORTS_BY_DOC_TYPES = 'FETCH_ALL_REPORTS_BY_DOC_TYPES'
export const ALL_REQUEST_DOCS_LIST = 'ALL_REQUEST_DOCS_LIST'
export const IS_SEARCH = 'IS_SEARCH'

export const LIST_ALL_PO = "LIST_ALL_PO"
export const PO_LIST_ERROR = "PO_LIST_ERROR"
export const PO_DETAIL_DATA = "PO_DETAIL_DATA"
export const REQUEST_CIRCLE_DOCS_LIST = 'REQUEST_CIRCLE_DOCS_LIST'
export const REQUEST_CIRCLE_DOCS_LIST_COUNT = 'REQUEST_CIRCLE_DOCS_LIST_COUNT'
export const ADD_PROGRAM_DOC_TYPE_DATA = 'ADD_PROGRAM_DOC_TYPE_DATA'
export const ON_NEW_REQUEST_DOCUMENT = 'ON_NEW_REQUEST_DOCUMENT'


// Additional Fields Information
export const PORTAL_ADDITIONAL_FIELD_DATA = "PORTAL_ADDITIONAL_FIELD_DATA"
export const PORTAL_ADDITIONAL_FIELD_ERROR = "PORTAL_ADDITIONAL_FIELD_ERROR"
export const REQUEST_ADDITIONAL_FIELD_DATA = "REQUEST_ADDITIONAL_FIELD_DATA"

export const GET_ASSETS_COUNT_DATA = "GET_ASSETS_COUNT_DATA"
export const GET_ASSETS_COUNT_ERROR = "GET_ASSETS_COUNT_ERROR"
export const ALL_REQUEST_LIST_SUCCESS = "ALL_REQUEST_LIST_SUCCESS"
export const ALL_REQUEST_LIST_ERROR = "ALL_REQUEST_LIST_ERROR"

export const REQUEST_FILTER_OPTIONS_SUCCESS = "REQUEST_FILTER_OPTIONS_SUCCESS"
export const REQUEST_FILTER_OPTIONS_ERROR = "REQUEST_FILTER_OPTIONS_ERROR"

export const REPORT_MODULE_DATA = "REPORT_MODULE_DATA"
export const REPORT_MODULE_ERR = "REPORT_MODULE_ERR"
export const REPORT_MODULE_ADD = "REPORT_MODULE_ADD"
export const GROUP_DATA = "GROUP_DATA"
export const UPDATE_PORTAL_GROUP_DATA = "UPDATE_PORTAL_GROUP_DATA"
export const GROUP_ID = "GROUP_ID"
export const GROUP_ADD = "GROUP_ADD"
export const GROUP_ERR = "GROUP_ERR"

export const REQ_TYPE_DATA = "REQ_TYPE_DATA"
export const REQ_TYPE_ERR = "REQ_TYPE_ERR"

export const P_COUNTRY_DATA = "P_COUNTRY_DATA"
export const P_COUNTRY_ERR = "P_COUNTRY_ERR"

export const SITE_DATA = "SITE_DATA"
export const SITE_ERR = "SITE_ERR"

export const USER_ADDED = "USER_ADDED"
export const USER_UPDATED = "USER_UPDATED"
export const USER_ERR = "USER_ERR"
export const USER_BY_ID_INFO = "USER_BY_ID_INFO"
export const LIST_USER = "LIST_USER"
export const PORTAL_USER_PAGE_LAST_EVALUATED_KEY = "PORTAL_USER_PAGE_LAST_EVALUATED_KEY"
export const DELETE_USER = "DELETE_USER"
export const USER_GROUP = "USER_GROUP"
export const PORTAL_USER_GROUP = "PORTAL_USER_GROUP"
export const USER_GROUP_REF_KEY = "USER_GROUP_REF_KEY"
export const USER_GROUP_ERR = "USER_GROUP_ERR"
export const PORTAL_USER_GROUP_ERR = "PORTAL_USER_GROUP_ERR"
export const PORTAL_USER_UPDATED = "PORTAL_USER_UPDATED"
export const PORTAL_USER_COUNTRIES_LIST = 'PORTAL_USER_COUNTRIES_LIST'
export const USER_COUNTRIES_LIST = 'USER_COUNTRIES_LIST'
export const USER_COUNTRIES_ERROR = 'USER_COUNTRIES_ERROR'
export const ALL_PORTAL_USER_COUNTRIES_LIST = "ALL_PORTAL_USER_COUNTRIES_LIST"
export const PORTAL_USER_COUNTRIES_LIST_ERROR = 'PORTAL_USER_COUNTRIES_LIST_ERROR'
export const PORTAL_USER_COUNTRIES_ADDED_SUCCESS = 'PORTAL_USER_COUNTRIES_ADDED_SUCCESS'
export const PORTAL_USER_COUNTRIES_ADDED_ERROR = 'PORTAL_USER_COUNTRIES_ADDED_ERROR'
export const DELETED_USER_COUNTRY = 'DELETED_USER_COUNTRY'
export const DELETED_USER_COUNTRY_ERROR = 'DELETED_USER_COUNTRY_ERROR'

export const GET_ADDITIONAL_INFO = "GET_ADDITIONAL_INFO"

// Verification Of User Password Functionality.
export const INITIATE_SET_PASSWORD_SUCCESS = "INITIATE_SET_PASSWORD_SUCCESS"
export const PORTAL_USER_ACTIVATION_FAILED = "PORTAL_USER_ACTIVATION_FAILED"
export const INITIATE_UNAUTHORIZED_ACCESS = "INITIATE_UNAUTHORIZED_ACCESS"
export const USER_ACCOUNT_ACTIVATED_FAILED = "USER_ACCOUNT_ACTIVATED_FAILED"
export const USER_ACTIVATION_INITIATE_RESEND_ACTIVATION = "USER_ACTIVATION_INITIATE_RESEND_ACTIVATION"
export const PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS = "PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS"
export const PORTAL_USER_RESET_PASSWORD_FAILED = "PORTAL_USER_RESET_PASSWORD_FAILED"
export const NEW_USER_ADDED = "NEW_USER_ADDED"
export const INDV_PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS = "INDV_PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS"
export const PORTAL_USER_ACTIVATION_RESEND_FAILED = "PORTAL_USER_ACTIVATION_RESEND_FAILED"

export const USER_LOCATION_DETAILS_SUCCESS = 'USER_LOCATION_DETAILS_SUCCESS'
export const USER_LOCATION_DETAILS_FAILED = 'USER_LOCATION_DETAILS_FAILED'

export const COUNTRY_DATA_SUCCESS = 'COUNTRY_DATA_SUCCESS'
export const COUNTRY_DATA_ERROR = 'COUNTRY_DATA_ERROR'
export const COUNTRY_UOM_SUCCESS = 'COUNTRY_UOM_SUCCESS'

//home customer

export const REQUEST_DETAILS = 'REQUEST_DETAILS'
export const REQUEST_DETAILS_COUNT = "REQUEST_DETAILS_COUNT"
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'
export const REQUEST_SUCCESS_MESSAGE = 'REQUEST_SUCCESS_MESSAGE'
export const COLLECTION_ADDRESS_SUCCESS = "COLLECTION_ADDRESS_SUCCESS"
export const REQUEST_DETAILS_BY_REQUESTID = 'REQUEST_DETAILS_BY_REQUESTID'
export const REQUEST_CARRIER_LABELS = 'REQUEST_CARRIER_LABELS'
export const REQUEST_CARRIER_LABELS_ERROR = 'REQUEST_CARRIER_LABELS_ERROR'
export const USER_DETAILS = "USER_DETAILS"
export const HOME_CUSTOMER_REQUEST_TYPES = "HOME_CUSTOMER_REQUEST_TYPES"
export const COGNITO_USER_DETAILS = "COGNITO_USER_DETAILS"
export const COGNITO_USER_DETAILS_FAILED = "COGNITO_USER_DETAILS_FAILED"
export const USER_LOGIN_DETAILS = "USER_LOGIN_DETAILS"
export const USER_LOGIN_DETAILS_FAILED = "USER_LOGIN_DETAILS_FAILED"
export const USER_SUCCESS = "USER_SUCCESS"
export const USER_FAILED = "USER_FAILED"
export const REQUEST_FAILED = "REQUEST_FAILED"
export const COLLECTION_ADDRESS_DETAILS = "COLLECTION_ADDRESS_DETAILS"
export const COLLECTION_ADDRESS_DETAILS_FAILED = "COLLECTION_ADDRESS_DETAILS_FAILED"
export const ALL_COUNTRY_LIST = "ALL_COUNTRY_LIST"
export const ALL_COUNTRY_LIST_FAILED = "ALL_COUNTRY_LIST_FAILED"
export const PORTAL_COUNTRIES = "PORTAL_COUNTRIES"
export const PORTAL_COUNTRY_LIST = "PORTAL_COUNTRY_LIST"
export const PORTAL_COUNTRIES_FAILED = "PORTAL_COUNTRIES_FAILED"
export const PORTAL_ASSETS = "PORTAL_ASSETS"
export const PORTAL_ASSETS_FAILED = "PORTAL_ASSETS_FAILED"
export const UPLOAD_BULK_USERS = "UPLOAD_BULK_USERS"
export const UPLOAD_BULK_REQUESTS = "UPLOAD_BULK_REQUESTS"
export const BULK_USERS_ERROR = "BULK_USERS_ERROR"
export const INITIATE_UNAUTHORIZED_ACCESS_FOR_HOME_USER = "INITIATE_UNAUTHORIZED_ACCESS_FOR_HOME_USER"
export const IS_HOME_USER_AUTHENTICATED = "IS_HOME_USER_AUTHENTICATED"
export const HOME_BRANDS = "HOME_BRANDS"
export const PORTAL_STATUSES = "PORTAL_STATUSES"
export const PORTAL_STATUSES_ERROR = "PORTAL_STATUSES_ERROR"
export const ALL_PORTAL_STATUSES = "ALL_PORTAL_STATUSES"
export const USER_DETAILS_BY_USER_ID = "USER_DETAILS_BY_USER_ID"
export const USER_DETAILS_BY_USER_ID_FAILED = "USER_DETAILS_BY_USER_ID_FAILED"
export const USER_ACCESS_TOKEN = "USER_ACCESS_TOKEN"
export const USER_ACCESS_TOKEN_FAILED = "USER_ACCESS_TOKEN_FAILED"
export const CULTURES_DETAIL_SUCCESS = "CULTURES_DETAIL_SUCCESS"
export const CULTURES_DETAIL_ERROR = "CULTURES_DETAIL_ERROR"

/* Pickup Assets */
export const PICKUP_ASSETS_LIST_SUCCESS = "PICKUP_ASSETS_LIST_SUCCESS"
export const PICKUP_ASSETS_LIST_ERROR = "PICKUP_ASSETS_LIST_ERROR"
export const LIST_ALL_ASSETS_TYPE_SUCCESS = "LIST_ALL_ASSETS_TYPE_SUCCESS"
export const LIST_ALL_ASSETS_TYPE_ERROR = "LIST_ALL_ASSETS_TYPE_ERROR"
export const LIST_REQUESTID_VIA_LOCATION_SUCCESS = "LIST_REQUESTID_VIA_LOCATION_SUCCESS"
export const LIST_REQUESTID_VIA_LOCATION_ERROR = "LIST_REQUESTID_VIA_LOCATION_ERROR"
export const SEND_CREATE_ORDER_REQUEST_SUCCESS = "SEND_CREATE_ORDER_REQUEST_SUCCESS"
export const SEND_CREATE_ORDER_REQUEST_ERROR = "SEND_CREATE_ORDER_REQUEST_ERROR"
export const ADD_PICKUP_ASSETS_TO_EXISTS_REQUEST_SUCCESS = "ADD_PICKUP_ASSETS_TO_EXISTS_REQUEST_SUCCESS"
export const ADD_PICKUP_ASSETS_TO_EXISTS_REQUEST_ERROR = "ADD_PICKUP_ASSETS_TO_EXISTS_REQUEST_ERROR"
export const BULK_UPLOAD_COLLECTION_SITES = "BULK_UPLOAD_COLLECTION_SITES"

export const PORTAL_STORYBOARD_ASSETS = "PORTAL_STORYBOARD_ASSETS"
export const PORTAL_STORYBOARD_REPORT_EXPORT = "PORTAL_STORYBOARD_REPORT_EXPORT"
export const PORTAL_STORYBOARD_INVENTORY_REPORT = "PORTAL_STORYBOARD_INVENTORY_REPORT"
export const PORTAL_STORYBOARD_REQUEST_SUMMARY = "PORTAL_STORYBOARD_REQUEST_SUMMARY"
export const PORTAL_STORYBOARD_SETTLEMENT_SUMMARY = "PORTAL_STORYBOARD_SETTLEMENT_SUMMARY"
export const PORTAL_STORYBOARD_FETCH_ERROR = "PORTAL_STORYBOARD_FETCH_ERROR"

/* PORTAL USER COMPANY */
export const ADD_PORTAL_USER_COMPANIES = "ADD_PORTAL_USER_COMPANIES"
export const FETCH_PORTAL_USER_COMPANIES = "FETCH_PORTAL_USER_COMPANIES"
export const PROGRAM_COMPANY_LIST = "PROGRAM_COMPANY_LIST"
export const ADD_NEW_COMPANY_ERROR = "ADD_NEW_COMPANY_ERROR"
export const SET_ADD_NEW_COMPANY_RESPONSE = "SET_ADD_NEW_COMPANY_RESPONSE"
export const DELETE_PROGRAM_COMPANY = "ELETE_PROGRAM_COMPANY"
export const ADD_PROGRAM_COMPANY = "ADD_PROGRAM_COMPANY"

/* CURRENCY */
export const LIST_CURRENCY = "LIST_CURRENCY";
export const LIST_CURRENCY_ERR = "LIST_CURRENCY_ERR";

/* PICKUP DATE */
export const SAVE_PICKUP_DATE = "SAVE_PICKUP_DATE"
export const SAVE_PICKUP_DATE_ERROR = "SAVE_PICKUP_DATE_ERROR"

export const LIST_ALL_SUPERVISOR_USER_ACCESS = "LIST_ALL_SUPERVISOR_USER_ACCESS"

export const GET_ALL_PROGRAM_LANGUAGES_SUCCESS = "GET_ALL_PROGRAM_LANGUAGES_SUCCESS";
export const PROGRAM_LANGUAGES_ERROR = "PROGRAM_LANGUAGES_ERROR"
export const PORTAL_QRCODE_DATA = "PORTAL_QRCODE_DATA"
export const PORTAL_QRCODE_ERROR = "PORTAL_QRCODE_ERROR"

export const GET_PROGRAM_RECURSIVE_REQUEST = "GET_PROGRAM_RECURSIVE_REQUEST"
export const ADD_RECURSIVE_REQUEST = "ADD_RECURSIVE_REQUEST"
export const RECURSIVE_REQUEST_ERROR = "RECURSIVE_REQUEST_ERROR"
export const NUMBER_REQUEST_EACH_SERVICE_TYPE = "NUMBER_REQUEST_EACH_SERVICE_TYPE"
export const List_NEW_REQUESTS = "List_NEW_REQUESTS"

export const HOLIDAY_FETCHED = "HOLIDAY_FETCHED"
export const HOLIDAY_ERROR = "HOLIDAY_ERROR"

export const PROGRAM_PALLET_SUCCESS = "PROGRAM_PALLET_SUCCESS"
export const REQUEST_PALLET_SUCCESS = "REQUEST_PALLET_SUCCESS"
export const PROGRAM_PALLET_ERROR = "PROGRAM_PALLET_ERROR"

export const SET_BULK_UPLOAD_ASSET_DATA_SUCCESS = "SET_BULK_UPLOAD_ASSET_DATA_SUCCESS"

export const GET_LIST_USER_NOTIFICATION = "GET_LIST_USER_NOTIFICATION"
export const REQUEST_LIST_USER_NOTIFICATION_ERROR = "REQUEST_LIST_USER_NOTIFICATION_ERROR"


export const GET_LIST_RECENT_ACCESS = "GET_LIST_RECENT_ACCESS"
export const CREATE_RECENT_ACCESS = "CREATE_RECENT_ACCESS"
export const REQUEST_RECENT_ACCESS_ERROR = "REQUEST_RECENT_ACCESS_ERROR"
export const SET_OPEN_REQUEST_ACCESS = "SET_OPEN_REQUEST_ACCESS"

/* Documents */
export const STANDARD_REPORTS_LIST = "STANDARD_REPORTS_LIST"
export const SERVICE_DOCS_LIST = "SERVICE_DOCS_LIST"
export const OTHER_DOCS_LIST = "FETCH_SERVICE_DOCUMENTS"
export const DOCUMENTS_ERROR = "DOCUMENTS_ERROR"
export const LIST_DOC_TYPES = "LIST_DOC_TYPES"
export const LIST_DOC_TAGS = "LIST_DOC_TAGS"
export const LIST_REPORT_ASSETS = "LIST_REPORT_ASSETS"
export const LIST_REPORT_ASSETS_BY_REQUEST_ID = "LIST_REPORT_ASSETS_BY_REQUEST_ID"
export const LIST_PORTAL_DOC_TYPES = "LIST_PORTAL_DOC_TYPES"
export const DOCUMENT_TYPES_ERROR = "DOCUMENT_TYPES_ERROR"
export const GET_SAVE_FILTERS_BY_USER_ID = "GET_SAVE_FILTERS_BY_USER_ID"
export const GET_USER_SAVED_FILTERS='GET_USER_SAVED_FILTERS'
export const GET_DOCUMENT_FILTER_INFO='GET_DOCUMENT_FILTER_INFO'
export const REQUEST_LIST_NOTICE_ERROR = "REQUEST_LIST_NOTICE_ERROR"
export const REQUEST_NOTICE_DETAIL_ERROR = "REQUEST_NOTICE_DETAIL_ERROR"

export const REQUEST_LIST_INQUIRY_ERROR = "REQUEST_LIST_INQUIRY_ERROR"
export const REQUEST_LIST_INQUIRY_TRACKING_STATUS_ERROR = "REQUEST_LIST_INQUIRY_TRACKING_STATUS_ERROR"
export const REQUEST_LIST_INQUIRY_STATUS_ERROR = "REQUEST_LIST_INQUIRY_STATUS_ERROR"
export const REQUEST_LIST_INQUIRY_CATEGORY_ERROR = "REQUEST_LIST_INQUIRY_CATEGORY_ERROR"
export const REQUEST_INQUIRY_DETAIL_ERROR = "REQUEST_INQUIRY_DETAIL_ERROR"
export const UPDATE_INQUIRY_COMMENT_ERROR = "UPDATE_INQUIRY_COMMENT_ERROR"
export const CREATE_INQUIRY_COMMENT_ERROR = "CREATE_INQUIRY_COMMENT_ERROR"
export const DELETE_INQUIRY_COMMENT_ERROR = "DELETE_INQUIRY_COMMENT_ERROR"
export const UPDATE_INQUIRY_STATUS_ERROR = "UPDATE_INQUIRY_STATUS_ERROR"
export const CREATE_NEW_INQUIRY_ERROR = "CREATE_NEW_INQUIRY_ERROR"
export const UPLOAD_FILE_ERROR = "UPLOAD_FILE_ERROR"
export const GET_LIST_INQUIRY_CATEGORY_SUCCESS = "GET_LIST_INQUIRY_CATEGORY_SUCCESS"
export const RESOLVE_INQUIRY_ERROR = "RESOLVE_INQUIRY_ERROR"
export const REOPEN_INQUIRY_ERROR = "REOPEN_INQUIRY_ERROR"
export const UPDATE_INQUIRY_ERROR = "UPDATE_INQUIRY_ERROR"

export const REQUEST_ACCESS_LIST="REQUEST_ACCESS_LIST"
export const REQUEST_ACCESS_LIST_ERROR = "REQUEST_ACCESS_LIST_ERROR"
export const REQUEST_ACCESS_DETAIL="REQUEST_ACCESS_DETAIL"
export const REQUEST_ACCESS_DETAIL_ERROR="REQUEST_ACCESS_DETAIL_ERROR"
